import {Component, OnInit} from '@angular/core';
import {catchError, debounceTime, distinctUntilChanged, switchMap, tap} from 'rxjs/operators';
import {Observable, of} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {NgbHighlight, NgbTypeahead} from '@ng-bootstrap/ng-bootstrap';
import {ConsultingService, LoaderService, SalesService} from '@app/shared/services';
import {ToastrService} from 'ngx-toastr';
import {SelectDropDownModule} from 'ngx-select-dropdown';
import {PageHeaderComponent} from '@app/components/page-header/page-header.component';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {UtilsInjectable} from '@app/shared';

@Component({
  selector: 'app-add-damage',
  templateUrl: './add-damage.component.html',
  imports: [
    CommonModule,
    FormsModule,
    SelectDropDownModule,
    PageHeaderComponent,
    NgbHighlight,
    NgbTypeahead
  ],
  styleUrls: ['./add-damage.component.scss']
})
export class AddDamageComponent implements OnInit {
  public damage: any =
    {
      damage_id: 0,
      purchase_id: 0,
      invoice_no: '',
      medicine_ids: [""],
      medicine_id: 0,
      unitprice: [""],
      sellingprice: [""],
      slab_a_per: [""],
      slab_a_amount: [""],
      slab_b_per: [""],
      slab_b_amount: [""],
      slab_c_per: [""],
      slab_c_amount: [""],
      web_per: [""],
      web_amount: [""],
      user_id: '',
      vat: [""],
      flood: [""],
      slab_a_flood: [""],
      slab_b_flood: [""],
      slab_c_flood: [""],
      medicine_data: [],
      medicine_id_arr: [""],
      quantity_arr: [""],
      uom_arr: [""],
      uom_arr_name: [""],
      paking_arr: [""],
      amount_arr: [""],
      actual_arr: [""],
      unitprice_arr: [""],
      retailprice_arr: [""],
      dis_arr: [""],
      available_qty: [""],
      order_quantity: [""],
      received_quantity: [""],
      freebie_arr: ["0"],
      purchased_quantity_arr: [""],
      vat_arr: [""],
      vat_amt_arr: [""],
      gross_arr: [""],
      real_damage_quantity: [0],
      damage_quantity_arr: [""],
      damage_reason_arr: [""],
      damage_amount_arr: [""],
      purchase_details_id: [""],
      damage_purchase_details_id: [""],
      edit_quantity: [""],
      rate: [""],
      freight: [""],
      search_text: "",
      total_amount: 0,
      check: [false]
    }
  public purchase_details: any = [];
  invoice: any = [""];
  invoice_options: any;
  invoice_data: any;
  item_list: any;
  user_rights: any;
  user_data: any;
  searching = false;
  searchFailed = false;
  purchase_data: any;
  damaged: any;
  damage_quantity: any = [];
  toaste: ToastrService

  constructor(private loaderService: LoaderService,
              protected utils: UtilsInjectable,
              public salesService: SalesService,
              public toastrService: ToastrService,
              public consultingService: ConsultingService,
              private router: Router,
              private route: ActivatedRoute) {
    this.toaste = toastrService
  }

  ngOnInit() {
    this.user_rights = JSON.parse(localStorage.getItem('user_rights') || "{}");
    this.user_data = JSON.parse(localStorage.getItem('user') || "{}");
    this.listInvoices();
    this.route.params.subscribe(params => {
      this.damage.damage_id = Number.parseInt(params['damage_id']);
      this.listInvoices();

    });
    const id = +(this.route.snapshot.paramMap.get('id') || "");
    if (id != null && id != 0) {
      this.damage.damage_id = id;
      this.getDamage(this.damage.damage_id);
    } else {
      this.listInvoices();
    }
  }

  public cleardata() {
    this.invoice_data = ""
    this.purchase_details = [];
    this.damage =
      {
        damage_id: 0,
        purchase_id: 0,
        invoice_no: '',
        medicine_ids: [""],
        medicine_id: 0,
        unitprice: [""],
        sellingprice: [""],
        slab_a_per: [""],
        slab_a_amount: [""],
        slab_b_per: [""],
        slab_b_amount: [""],
        slab_c_per: [""],
        slab_c_amount: [""],
        web_per: [""],
        web_amount: [""],
        user_id: '',
        vat: [""],
        flood: [""],
        slab_a_flood: [""],
        slab_b_flood: [""],
        slab_c_flood: [""],
        medicine_data: [],
        medicine_id_arr: [""],
        quantity_arr: [""],
        uom_arr: [""],
        uom_arr_name: [""],
        paking_arr: [""],
        amount_arr: [""],
        actual_arr: [""],
        unitprice_arr: [""],
        retailprice_arr: [""],
        dis_arr: [""],
        available_qty: [""],
        order_quantity: [""],
        received_quantity: [""],
        freebie_arr: ["0"],
        purchased_quantity_arr: [""],
        vat_arr: ["0"],
        gross_arr: [""],
        damage_quantity_arr: [""],
        real_damage_quantity: [0],
        damage_reason_arr: [""],
        damage_amount_arr: [""],
        damage_purchase_details_id: [""],
        purchase_details_id: [""],
        edit_quantity: [""],
        rate: [""],
        freight: [""],
        search_text: "",
        total_amount: 0,
        check: [false]
      }
  }

  public getDamage(damage_id: any) {
    const postData = {

      damage_id: damage_id
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.salesService.getDamage(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.damaged = result['data'];
        this.damage.purchase_id = this.damaged.PURCHASE_ID
        this.damage.vendor_id = this.damaged.VENDOR_ID;
        this.damage.invoice_no = this.damaged.INVOICE_NUMBER;
        this.damage.invoice_date = this.damaged.INVOICE_DATE;
        this.damage.damage_id = this.damaged.DAMAGE_PURCHASE_ID;
        this.item_list = result['data'].DAMAGE;
        let i = 0;
        this.purchase_details = ['0'];
        const purchase_details = [];
        for (const item of result['data'].DAMAGE) {
          purchase_details.push(i);
          this.damage.medicine_data[i] = {
            'MEDICINE_ID': item.MEDICINE_ID,
            'TRADE_NAME': item.TRADE_NAME,
            'DDC_CODE': item.DDC_CODE,
            'SCIENTIFIC_CODE': item.SCIENTIFIC_CODE,
            'SCIENTIFIC_NAME': item.SCIENTIFIC_NAME
          };
          this.damage.medicine_id_arr[i] = item.MEDICINE_ID;
          this.damage.uom_arr[i] = item.UNIT;
          this.damage.uom_arr_name[i] = item.UNIT_DESC;
          this.damage.quantity_arr[i] = item.QUANTITY;
          this.damage.available_qty[i] = item.AVAILABLE_STOCK_QUANTITY
          this.damage.uom_arr[i] = item.UNIT;
          this.damage.actual_arr[i] = item.ACTUAL_AMOUNT
          this.damage.uom_arr_name[i] = item.UNIT_DESC;
          this.damage.damage_reason_arr[i] = item.DAMAGE_DESCRIPTION;
          this.damage.amount_arr[i] = item.AMOUNT;
          this.damage.unitprice_arr[i] = item.UNIT_PRICE;
          this.damage.damage_amount_arr[i] = item.DAMAGE_RATE;
          this.damage.damage_quantity_arr[i] = item.DAMAGE_QUANTITY;
          this.damage.damage_purchase_details_id[i] = item.DAMAGE_PURCHASE_DETAILS_ID;
          this.damage.purchase_details_id[i] = item.PURCHASE_DETAILS_ID;
          this.damage_quantity[i] = item.DAMAGE_QUANTITY;
          this.damage.check[i] = item.DAMAGE_QUANTITY > 0;

          i = i + 1;
        }
        this.purchase_details = purchase_details;
        this.total();
        this.getDamageUnitPrice();
        this.setInvoice();
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
      }
    });
  }

  public total() {
    let sum = 0;
    this.damage.quantity_arr.forEach((item: any, index: any) => {
      if (this.damage.check[index] == true) {
        const total = parseFloat(this.damage.damage_amount_arr[index]);
        if (!isNaN(total)) {
          sum = sum + total
        }
      }
    });
    this.damage.total_amount = (sum);
  }

  public getDamageQty() {
    this.damage_quantity.forEach((item: any, index: any) => {
      if (this.damage.check[index] == true) {
        const damageqty = parseInt(this.damage.damage_quantity_arr[index]);
        const predamageqty = parseInt(this.damage_quantity[index]);
        if (!isNaN(damageqty && predamageqty)) {
          if (predamageqty < damageqty) {
            this.damage.real_damage_quantity[index] = ''
            this.damage.real_damage_quantity[index] = -(damageqty - predamageqty)
          } else {
            this.damage.real_damage_quantity[index] = ''
            this.damage.real_damage_quantity[index] = predamageqty - damageqty
          }
        }
      }
    });
  }

  public set_item_medicine($event: any, i: any) {

    const item = $event.item;
    this.damage.medicine_id_arr[i] = item.MEDICINE_ID;
    this.damage.uom_arr[i] = item.UNIT;
    this.damage.uom_arr_name[i] = item.UNIT_DESC;
    this.damage.available_qty[i] = item.AVAILABLE_STOCK_QUANTITY;
    this.damage.medicine_id_arr[i] = item.MEDICINE_ID;
    this.damage.quantity_arr[i] = item.QUANTITY;
    this.damage.uom_arr[i] = item.UNIT;
    this.damage.actual_arr[i] = item.ACTUAL_AMOUNT
    this.damage.uom_arr_name[i] = item.UNIT_DESC;
    this.damage.paking_arr[i] = item.DESCRIPTION;
    this.damage.amount_arr[i] = item.AMOUNT;
    this.damage.unitprice_arr[i] = item.UNIT_PRICE;
    this.damage.retailprice_arr[i] = item.MRP;
    this.damage.dis_arr[i] = item.DISCOUNT;
    this.damage.purchase_details_id[i] = item.PURCHASE_DETAILS_ID;

  }

  public listPurchaseItems() {
    const postData = {
      invoice_no: this.invoice_data.INVOICE_NUMBER,
      purchase_id: this.invoice_data.PURCHASE_ID,
    };
    this.damage.purchase_id = this.invoice_data.PURCHASE_ID;
    this.loaderService.display(true);
    this.salesService.getPurchase(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.purchase_data = result['data'];
        let i = 0;
        this.purchase_details = ['0'];
        this.damage.vendor_id = this.purchase_data.VENDOR_ID;
        this.damage.invoice_no = this.purchase_data.INVOICE_NUMBER;
        this.damage.invoice_date = this.purchase_data.INVOICE_DATE;
        this.damage.purchase_id = this.purchase_data.PURCHASE_ID;
        if (this.purchase_data.DAMAGE_PURCHASE_ID)
          this.damage.damage_id = this.purchase_data.DAMAGE_PURCHASE_ID;
        console.log("this.damage.damage_id")
        console.log(this.damage.damage_id)
        const num_rows = [];
        for (const item of result['data'].PURCHASE) {
          const temp = {
            'MEDICINE_ID': item.MEDICINE_ID,
            'TRADE_NAME': item.TRADE_NAME,
            'HSN_CODE': item.HSN_CODE,
          };
          num_rows.push(i);
          this.damage.medicine_data[i] = temp;
          this.damage.medicine_id_arr[i] = item.MEDICINE_ID;
          this.damage.uom_arr[i] = item.UNIT;
          this.damage.uom_arr_name[i] = item.UNIT_DESC;
          this.damage.quantity_arr[i] = item.QUANTITY;
          this.damage.available_qty[i] = item.AVAILABLE_STOCK_QUANTITY
          this.damage.uom_arr[i] = item.UNIT;
          this.damage.actual_arr[i] = item.ACTUAL_AMOUNT
          this.damage.uom_arr_name[i] = item.UNIT_DESC;
          this.damage.damage_reason_arr[i] = item.DAMAGE_DESCRIPTION;
          this.damage.amount_arr[i] = item.AMOUNT;
          this.damage.unitprice_arr[i] = item.UNIT_PRICE;
          this.damage.damage_amount_arr[i] = item.DAMAGE_RATE;
          if (item.DAMAGE_QUANTITY) {
            this.damage.damage_quantity_arr[i] = item.DAMAGE_QUANTITY;
            this.damage.real_damage_quantity[i] = 0;
            this.damage_quantity[i] = item.DAMAGE_QUANTITY;
          } else {
            this.damage.damage_quantity_arr[i] = 0;
            this.damage.real_damage_quantity[i] = 0;
            this.damage_quantity[i] = 0;
          }
          this.damage.purchase_details_id[i] = item.PURCHASE_DETAILS_ID;
          this.damage.damage_purchase_details_id[i] = item.DAMAGE_PURCHASE_DETAILS_ID;

          this.damage.check[i] = item.DAMAGE_QUANTITY > 0;
          i = i + 1
        }

        this.purchase_details = num_rows
        this.total();
        this.getDamageUnitPrice();
        this.setInvoice();
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
        this.item_list = []
      }
    });
  }

  public changeCheckbox(i: any) {
    this.damage.check[i] = this.damage.check[i] != true;
  }

  public listInvoices() {
    window.scrollTo(0, 0)
    this.loaderService.display(true);
    this.salesService.listPurchaseInvoice().subscribe((result: any) => {
      this.loaderService.display(false);
      if (result['status'] == 'Success') {
        this.invoice = result['data'];
        this.invoice_options = this.invoice;
        for (let index = 0; index < this.invoice_options.length; index++) {
          if (this.invoice_options[index].PURCHASE_ID == this.damage.purchase_id) {
            this.invoice_data = this.invoice_options[index];
          }
        }
      }
    });
  }

  public setInvoice() {

    for (let index = 0; index < this.invoice.length; index++) {
      if (this.invoice[index].PURCHASE_ID == this.damage.purchase_id) {
        this.invoice_data = this.invoice[index];
        break;
      }
    }
  }

  getInvoice() {
    this.damage = {
      damage_id: 0,
      purchase_id: 0,
      invoice_no: '',
      medicine_ids: [""],
      medicine_id: 0,
      unitprice: [""],
      sellingprice: [""],
      slab_a_per: [""],
      slab_a_amount: [""],
      slab_b_per: [""],
      slab_b_amount: [""],
      flood: [""],
      slab_c_per: [""],
      slab_c_amount: [""],
      web_per: [""],
      web_amount: [""],
      user_id: '',
      edit_quantity: [""],
      vat: [""],
      slab_a_flood: [""],
      slab_b_flood: [""],
      slab_c_flood: [""],
      damage_purchase_details_id: [""],
      purchase_details_id: [""],
      rate: [""],
      total_amount: 0,
      freight: [""],
      search_text: "",
      medicine_data: [],
      medicine_id_arr: [""],
      quantity_arr: [""],
      uom_arr: [""],
      uom_arr_name: [""],
      paking_arr: [""],
      amount_arr: [""],
      actual_arr: [""],
      unitprice_arr: [""],
      retailprice_arr: [""],
      dis_arr: [""],
      available_qty: [""],
      order_quantity: [""],
      received_quantity: [""],
      freebie_arr: ["0"],
      purchased_quantity_arr: [""],
      vat_arr: ["0"],
      real_damage_quantity: [0],
      damage_quantity_arr: [""],
      damage_reason_arr: [""],
      damage_amount_arr: [""],
      gross_arr: [""],
      check: [false]
    }
    this.damage.purchase_id = this.invoice_data.PURCHASE_ID;
    this.damage.invoice_no = this.invoice_data.INVOICE_NUMBER;
    this.damage.damage_id = this.invoice_data.DAMAGE_PURCHASE_ID;
    this.listPurchaseItems();
  }

  public saveDamageProducts(): any {
    let rel = 1;
    let rels = 1;
    const isAnyChecked = this.damage.check && this.damage.check.some((val: any) => val === true);

    if (!isAnyChecked) {
        this.toaste.error('Please check at least one item before saving!');
        return false;
    }
    this.damage.medicine_id_arr.forEach((item: any, index: any): any => {
      if (this.damage.check[index] == true && this.damage.available_qty[index] > 0) {
        if (this.damage.damage_quantity_arr[index] == "" || this.damage.damage_quantity_arr[index] == 0 || this.damage.damage_quantity_arr[index] == null) {
          this.toaste.error('Enter quantity');
          rel = 0;
          return false;
        }
        if (this.damage.damage_quantity_arr[index] > 0) {
          rels = 0;
        }
        if (parseInt(this.damage.available_qty[index]) < parseInt(this.damage.damage_quantity_arr[index])) {
          this.toaste.error('Invalid quantity');
          rel = 0;
          return false;
        }
        if (parseInt(this.damage.purchased_quantity_arr[index]) < parseInt(this.damage.damage_quantity_arr[index])) {
          this.toaste.error('Invalid quantity');
          rel = 0;
          return false;
        }
        if (parseInt(this.damage.available_qty[index]) < parseInt(this.damage.damage_quantity_arr[index]) || parseInt(this.damage.purchased_quantity_arr[index]) < parseInt(this.damage.damage_quantity_arr[index])) {
          this.toaste.error('Invalid quantity');
          rel = 0;
          return false;
        }
      }
      if (this.damage.check[index] == true) {
        if (this.damage.damage_reason_arr[index] == "" || this.damage.damage_reason_arr[index] == null) {
          this.toaste.error('Please enter damage reason');
          rel = 0;
          return false;
        }
      }
    });
    if (rel == 0) {
      return false
    }
    if (rels == 0) {
      if (confirm("Are you sure to save the details ?")) {
        this.damage.user_id = this.user_data.user_id;
        this.loaderService.display(true);
        this.salesService.saveDamageProducts(this.damage).subscribe((result: any) => {
          window.scrollTo(0, 0)
          if (result["status"] == "Success") {
            this.loaderService.display(false);
            this.toaste.success(result.msg);
            this.router.navigate(['purchase/damage-list']).then();
            this.damage.damage_id = result.data_id;
            this.cleardata();
            this.damage.purchase_id = 0;
            this.purchase_details = []
          } else {
            this.toaste.error(result.msg);
            this.loaderService.display(false);
          }
        })
      }
    }
  }

  public round(data: any) {
    return Math.round(data)
  }

  public addrow(index: any) {
    this.purchase_details[index + 1] = {check: true};
    this.damage.medicine_data[index + 1] = '';
    this.damage.purchased_quantity_arr[index + 1] = '';
    this.damage.vat_arr[index + 1] = '0';
    this.damage.uom_arr_name[index + 1] = '';
    this.damage.uom_arr[index + 1] = '';
    this.damage.unitprice_arr[index + 1] = '';
    this.damage.retailprice_arr[index + 1] = '';
    this.damage.amount_arr[index + 1] = '';
    this.damage.paking_arr[index + 1] = '';
    this.damage.available_qty[index + 1] = '';
    this.damage.freebie_arr[index + 1] = '0';
    this.damage.gross_arr[index + 1] = '';
    this.damage.damage_quantity_arr[index + 1] = '';
    this.damage.damage_reason_arr[index + 1] = '';
    this.damage.damage_amount_arr[index + 1] = '';
    this.total();
  }

  public deleterow(index: any) {
    this.purchase_details.splice(index, 1);
    this.damage.medicine_data.splice(index, 1);
    this.damage.medicine_id_arr.splice(index, 1);
    this.damage.purchased_quantity_arr.splice(index, 1);
    this.damage.uom_arr.splice(index, 1);
    this.damage.uom_arr_name.splice(index, 1);
    this.damage.unitprice_arr.splice(index, 1);
    this.damage.amount_arr.splice(index, 1);
    this.damage.retailprice_arr.splice(index, 1);
    this.damage.paking_arr.splice(index, 1);
    this.damage.dis_arr.splice(index, 1);
    this.damage.available_qty.splice(index, 1);
    this.damage.freebie_arr.splice(index, 1);
    this.damage.gross_arr.splice(index, 1);
    this.damage.damage_quantity_arr.splice(index, 1);
    this.damage.damage_reason_arr.splice(index, 1);
    this.damage.damage_amount_arr.splice(index, 1);
    this.total();

  }

  public getDamageUnitPrice() {
    let price = 0;
    this.damage.damage_quantity_arr.forEach((item: any, index: any): any => {
      if (this.damage.check[index] == true) {
        const amount = parseFloat(this.damage.unitprice_arr[index]);
        const qty = parseInt(this.damage.damage_quantity_arr[index]);
        const avail_qty = parseInt(this.damage.available_qty[index]);
        const pur_qty = parseInt(this.damage.purchased_quantity_arr[index]);
        if (avail_qty < qty || pur_qty < qty) {
          this.toaste.error('Invalid quantity');
          return false;
        } else {
          if (!isNaN(amount && qty)) {
            price = amount * qty;
          }
        }
        this.damage.damage_amount_arr[index] = price.toFixed(2)
      }
    });
  }

  medicine_search = (text$: Observable<string>) => text$.pipe(
    debounceTime(500),
    distinctUntilChanged(),
    tap(() => this.searching = true,),
    switchMap(term =>
      this.consultingService.medicine_purchase_search(term, this.damage.vendor_id).pipe(
        tap(() => this.searchFailed = false),
        catchError(() => {
          this.searchFailed = true;
          return of([])
        })
      )
    ),
    tap(() => this.searching = false)
  )
  formatter = (x: { TRADE_NAME: string, HSN_CODE: string, MEDICINE_ID: number }): any => x.TRADE_NAME;
}
